import { cn } from '@/utils/mergeClassName';
import { dividerVariants } from './styles';

type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
};

export const Divider = ({ className, orientation = 'horizontal' }: DividerProps) => (
  <hr className={cn(dividerVariants({ orientation }), className)} />
);
